import { createContext } from "react";

const OfficeContext = createContext({
  officeName: 'Athlone',
  setOfficeName: (officeName) => {}
});

export default OfficeContext;